import { render, staticRenderFns } from "./property.vue?vue&type=template&id=5f964c72&scoped=true"
import script from "./property.vue?vue&type=script&lang=js"
export * from "./property.vue?vue&type=script&lang=js"
import style0 from "./property.vue?vue&type=style&index=0&id=5f964c72&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f964c72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f964c72')) {
      api.createRecord('5f964c72', component.options)
    } else {
      api.reload('5f964c72', component.options)
    }
    module.hot.accept("./property.vue?vue&type=template&id=5f964c72&scoped=true", function () {
      api.rerender('5f964c72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/components/property.vue"
export default component.exports